import { useDataValue } from 'Simple/Data.js'
/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props, data) {
  let carrier_id = useDataValue({
    context: 'plan_details',
    viewPath: props.viewPath,
    path: 'carrier',
  })
  return {
    variables: { carrier_id },
  }
}
